import { render } from "./RiNoticeNew.vue?vue&type=template&id=43950aaa"
import script from "./RiNoticeNew.vue?vue&type=script&lang=js"
export * from "./RiNoticeNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiNoticeNew.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43950aaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43950aaa', __exports__)) {
    api.reload('43950aaa', __exports__)
  }
  
  module.hot.accept("./RiNoticeNew.vue?vue&type=template&id=43950aaa", () => {
    api.rerender('43950aaa', render)
  })

}


export default __exports__